// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2N0_q","infected":"Cards_infected__YfFgs","recovered":"Cards_recovered__1NkLJ","deaths":"Cards_deaths__PQ9eP"};